import { AvailableSignalDTO, MeasurementSignalDTO } from '@shared/models';

export enum OperatingSignalsLoadType {
  Initial = 'initial',
  Additional = 'additional',
}

export interface LoadOperatingSignalsParams {
  machineId: string;
  signalTypeIds?: number[];
  dateHours?: number;
  loadType: OperatingSignalsLoadType;
}

export interface DateRangeType {
  startDate: string;
  endDate: string;
}

export interface OperatingSignalsStateModel {
  seriesData: MeasurementSignalDTO[];
  availableSignals: AvailableSignalDTO[];
  selectedSignalTypeIds: number[];
  predefinedSignalTypeIds: number[];
  currentMachineId: string | null;
  currentDateHours: number | null;
  isLoading: boolean;
  error: string | null;
  lastSignalReceived?: string | null;
  seriesDataByComponent?: { [component: string]: MeasurementSignalDTO[] };
}
